import { render } from "./AppSettings.vue?vue&type=template&id=296fa20e"
import script from "./AppSettings.vue?vue&type=script&lang=ts"
export * from "./AppSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script